// Actions
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_PLANS = "GET_PLANS";
export const CREATE_PLANS = "CREATE_PLANS";
export const UPDATE_PLANS = "UPDATE_PLANS";
export const DELETE_PLANS = "DELETE_PLANS";
